/**
 * Field validation constraints for virtual infrastructure forms
 * Centralizes size and validation limits to avoid magic numbers
 */

export const FIELD_CONSTRAINTS = {
    HOSTNAME: {
        size: 40,
        maxLength: 128,
    },
    USERNAME: {
        size: 40,
        maxLength: 128,
    },
    PASSWORD: {
        size: 40,
        maxLength: 65,
    },
    PORT: {
        size: 5,
        maxLength: 5,
        min: 1,
        max: 65535,
    },
    DESCRIPTION: {
        cols: 60,
        maxLength: 225,
    },
};

export const VERIFICATION_CONFIG = {
    pollingInterval: 2000,
    maxTimeout: 40000,
    maxAttempts: 15,
    timeFormat: {
        millisPerSecond: 1000,
        decimalPlaces: 1,
    },
};

export const LIST_CONFIG = {
    initialLoadTime: -1,
    visibleRows: 10,
    incrementValue: 1,
    firstItemIndex: 0,
};
